document.addEventListener('DOMContentLoaded', function() {
  const isProductPage = document.querySelector('.product') !== null || 
                        document.querySelector('[data-section-type="product-template"]') !== null || 
                        window.location.pathname.includes('/products/');

  /**
   * Formatiert die Preisanzeige auf Produktseiten
   */
  function formatProductPagePrices() {
    if (!isProductPage) return;

    // Reguläre Preise formatieren
    const regularPriceElements = document.querySelectorAll('.price__regular .price-item.price-item--regular:not(s)');
    regularPriceElements.forEach(function(element) {
      element.style.fontSize = '2rem';
      element.style.color = '#000000';
      element.style.fontWeight = 'bold';
      element.style.display = 'inline-block';
    });

    // Durchgestrichene Original-Preise formatieren
    const originalPriceElements = document.querySelectorAll('s.price-item.price-item--regular');
    originalPriceElements.forEach(function(element) {
      element.style.fontSize = '3rem';
      element.style.color = '#000000';
      element.style.fontWeight = 'bold';
      element.style.textDecoration = 'line-through';
      element.style.display = 'inline-block';
    });

    // Sale-Preise formatieren
    const salePriceElements = document.querySelectorAll('.price-item--sale, .price-item--last');
    salePriceElements.forEach(function(element) {
      element.style.fontSize = '2rem';
      element.style.color = '#008000';
      element.style.fontWeight = 'bold';
      element.style.display = 'inline-block';
    });

    // Sale-Badge mit Prozent-Rabatt ersetzen
    const saleBadges = document.querySelectorAll('.badge.price__badge-sale');
    if (saleBadges.length > 0) {
      const originalPriceEl = document.querySelector('s.price-item.price-item--regular');
      const salePriceEl = document.querySelector('.price-item--sale.price-item--last');
      
      if (originalPriceEl && salePriceEl) {
        const originalPriceText = originalPriceEl.textContent;
        const salePriceText = salePriceEl.textContent;
        const originalPriceValue = parseFloat(originalPriceText.replace(/[^0-9,.]/g, '').replace(/\./g, '').replace(',', '.'));
        const salePriceValue = parseFloat(salePriceText.replace(/[^0-9,.]/g, '').replace(/\./g, '').replace(',', '.'));
        
        if (!isNaN(originalPriceValue) && !isNaN(salePriceValue) && originalPriceValue > 0) {
          const discountPercentage = Math.round((1 - (salePriceValue / originalPriceValue)) * 100);
          
          saleBadges.forEach(function(badge) {
            if (badge.classList.contains('discount-percentage-badge-custom')) return;
            
            const discountBadge = document.createElement('div');
            discountBadge.className = 'badge price__badge-sale discount-percentage-badge-custom';
            discountBadge.textContent = '–' + discountPercentage + '%';
            discountBadge.style.backgroundColor = '#E5C9D7';
            discountBadge.style.color = '#000000';
            discountBadge.style.fontWeight = 'bold';
            discountBadge.style.fontSize = '2.5rem';
            discountBadge.style.padding = '10px 15px';
            discountBadge.style.borderRadius = '0px';
            discountBadge.style.display = 'inline-block';
            discountBadge.style.marginLeft = '12px';
            discountBadge.style.lineHeight = '1';
            
            if (badge.parentNode) {
              badge.parentNode.replaceChild(discountBadge, badge);
            }
          });
        }
      }
    }
  }

  /**
   * Fügt ein Gratis-Produkt-Banner hinzu (DEAKTIVIERT - wird jetzt durch Liquid-Block ersetzt)
   * Diese Funktion bleibt im Code, wird aber nicht mehr aufgerufen
   */
  function addFreeProductBanner() {
    if (!isProductPage) return;
    if (document.querySelector('.custom-free-product-banner-wrapper-mybearbrick')) {
      return;
    }
    
    const datenElement = document.getElementById('gratis-produkt-daten-container');
    if (datenElement) {
      const titel = datenElement.dataset.titel;
      const preisInCentsText = datenElement.dataset.preis;
      
      if (titel && preisInCentsText) {
        const preisInCents = parseInt(preisInCentsText, 10);
        
        if (!isNaN(preisInCents)) {
          const produktPreis = (preisInCents / 100);
          const shopifyCurrency = (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) 
            ? Shopify.currency.active 
            : 'EUR';
          const shopifyLocale = (typeof Shopify !== 'undefined' && Shopify.locale) 
            ? Shopify.locale 
            : 'de-DE';
          const formattedPrice = new Intl.NumberFormat(shopifyLocale, {
            style: 'currency',
            currency: shopifyCurrency
          }).format(produktPreis);
          
          let priceContainer = document.querySelector('.product__info-container .price');
          if (!priceContainer) priceContainer = document.querySelector('.product-form__info-item--price');
          if (!priceContainer) {
            const anyPriceElement = document.querySelector('.price-item, s.price-item, .price__regular, .price__sale');
            if (anyPriceElement) {
              priceContainer = anyPriceElement.closest('div[class*="price"], div.product__info-container, form[class*="product-form"]');
              if (!priceContainer) priceContainer = anyPriceElement.parentNode;
            }
          }
          
          if (priceContainer) {
            const wrapper = document.createElement('div');
            wrapper.className = 'product-availability-wrapper custom-free-product-banner-wrapper-mybearbrick';
            
            const banner = document.createElement('div');
            banner.className = 'product-availability-box custom-free-product-banner-mybearbrick';
            banner.style.backgroundColor = '#C9E5C9';
            
            const iconSpan = document.createElement('span');
            iconSpan.className = 'product-availability__icon';
            iconSpan.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="1em" height="1em" aria-hidden="true"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"/></svg>';
            
            const textSpan = document.createElement('span');
            textSpan.innerHTML = `Erhalte bei Bestellung jetzt GRATIS die <strong>${titel}</strong> im Wert von ${formattedPrice} dazu!`;
            
            banner.appendChild(iconSpan);
            banner.appendChild(textSpan);
            wrapper.appendChild(banner);
            priceContainer.insertAdjacentElement('beforebegin', wrapper);
          }
        }
      }
    }
  }

  /**
   * Rendert das Cart Drawer komplett neu mit aktuellen Daten
   */
  function refreshCartDrawer() {
    const cartDrawerElement = document.querySelector('cart-drawer');
    
    if (!cartDrawerElement) {
      console.error('[MyBearBrick] Cart Drawer Element nicht gefunden');
      return;
    }
    
    // Hole die komplette Cart Drawer Section neu vom Server
    fetch(window.location.origin + '/?sections=cart-drawer')
      .then(response => response.json())
      .then(sections => {
        // Die Response enthält die Section als JSON
        const cartDrawerHTML = sections['cart-drawer'];
        
        if (cartDrawerHTML) {
          // Parse das HTML
          const parser = new DOMParser();
          const doc = parser.parseFromString(cartDrawerHTML, 'text/html');
          const newCartDrawer = doc.querySelector('cart-drawer');
          
          if (newCartDrawer && cartDrawerElement.parentNode) {
            // Ersetze das alte Cart Drawer mit dem neuen
            cartDrawerElement.parentNode.replaceChild(newCartDrawer, cartDrawerElement);
            
            // Warte kurz, dann öffne das neue Cart Drawer
            setTimeout(function() {
              const refreshedCartDrawer = document.querySelector('cart-drawer');
              if (refreshedCartDrawer && typeof refreshedCartDrawer.open === 'function') {
                refreshedCartDrawer.open();
              } else {
                // Fallback: Manuell öffnen
                const cartDrawerDiv = document.getElementById('CartDrawer');
                if (cartDrawerDiv) {
                  cartDrawerDiv.classList.add('active');
                }
              }
            }, 100);
          }
        }
      })
      .catch(error => {
        console.error('[MyBearBrick Error] Fehler beim Aktualisieren des Cart Drawers:', error);
        // Fallback: Zur Warenkorbseite weiterleiten
        window.location.href = '/cart';
      });
  }

  /**
   * Interceptor für "In den Warenkorb"-Button
   * Fügt automatisch das Gratis-Produkt hinzu und öffnet das Cart Drawer
   */
  function initializeAddToCartInterceptor() {
    const addToCartButton = document.getElementById('ProductSubmitButton-template--25326689124618__main');
    
    if (addToCartButton) {
      if (addToCartButton.dataset.interceptorAttached === 'true') {
        return;
      }
      
      addToCartButton.addEventListener('click', function(event) {
        const currentForm = this.form;
        
        if (!currentForm) {
          console.error('[MyBearBrick Error] Zugehöriges Formular zum Button nicht gefunden.');
          return;
        }
        
        const gratisProduktDatenElement = document.getElementById('gratis-produkt-daten-container');
        const gratisProduktVarianteId = gratisProduktDatenElement 
          ? gratisProduktDatenElement.dataset.variantId 
          : null;
        
        const formData = new FormData(currentForm);
        const hauptProduktVarianteId = formData.get('id');
        const hauptProduktMenge = parseInt(formData.get('quantity') || '1', 10);
        
        if (gratisProduktDatenElement && gratisProduktVarianteId) {
          event.preventDefault();
          event.stopPropagation();
          
          if (!gratisProduktVarianteId) {
            console.error('[MyBearBrick Error] Interne Logik: Gratisprodukt-Variante-ID ist trotz Prüfung leer.');
            const submitButtonFromClick = this;
            if (submitButtonFromClick) submitButtonFromClick.disabled = false;
            return;
          }
          
          const submitButton = this;
          if (submitButton) submitButton.disabled = true;
          
          // Hauptprodukt zum Warenkorb hinzufügen
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: hauptProduktVarianteId,
                quantity: hauptProduktMenge
              }]
            })
          })
          .then(response => response.json())
          .then(dataHauptprodukt => {
            if (dataHauptprodukt.status === 'error' || !dataHauptprodukt.items || dataHauptprodukt.items.length === 0) {
              console.error('[MyBearBrick Error] Fehler beim Hinzufügen des Hauptprodukts:', 
                dataHauptprodukt.description || dataHauptprodukt.message || 'Antwort-Daten fehlerhaft');
              throw new Error(dataHauptprodukt.description || dataHauptprodukt.message || 'Hauptprodukt nicht hinzugefügt');
            }
            
            // Gratisprodukt zum Warenkorb hinzufügen
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: gratisProduktVarianteId,
                  quantity: 1
                }]
              })
            });
          })
          .then(response => response.json())
          .then(dataGratisprodukt => {
            if (dataGratisprodukt.status === 'error' || !dataGratisprodukt.items || dataGratisprodukt.items.length === 0) {
              console.error('[MyBearBrick Error] Fehler beim Hinzufügen des Gratisprodukts:', 
                dataGratisprodukt.description || dataGratisprodukt.message || 'Antwort-Daten fehlerhaft');
              throw new Error(dataGratisprodukt.description || dataGratisprodukt.message || 'Gratisprodukt nicht hinzugefügt');
            }
            
            // Cart Drawer komplett neu rendern und öffnen
            refreshCartDrawer();
            
            // Submit-Button wieder aktivieren
            if (submitButton) submitButton.disabled = false;
          })
          .catch((error) => {
            console.error('[MyBearBrick Error] Gesamtfehler beim Hinzufügen zum Warenkorb:', error);
            alert('Es gab einen Fehler beim Hinzufügen zum Warenkorb: ' + error.message + '. Bitte versuchen Sie es später erneut.');
            if (submitButton) submitButton.disabled = false;
          });
        } else {
          // Kein Gratisprodukt vorhanden - normales Verhalten
        }
      }, true);
      
      addToCartButton.dataset.interceptorAttached = 'true';
    } else {
      // Button nicht gefunden
    }
  }

  /**
   * Initialisiert alle Anpassungen
   */
  function initializeCustomizations() {
    formatProductPagePrices();
    // addFreeProductBanner(); // DEAKTIVIERT - wird jetzt durch Liquid-Block ersetzt
    
    if (isProductPage) {
      initializeAddToCartInterceptor();
    }
  }

  // Initialisierung mit mehreren Versuchen für unterschiedliche Lade-Timings
  initializeCustomizations();
  setTimeout(initializeCustomizations, 500);
  setTimeout(initializeCustomizations, 1000);
  setTimeout(initializeCustomizations, 2000);
});